import { isNumber } from "@fiken/components"

export function isKontonummer(konto: string | undefined): boolean {
  return konto !== undefined && konto.length === 4 && isNumber(konto)
}
